import { createFileRoute } from '@tanstack/react-router'
import { ProtectedRoute } from '../components/protected-route'
import LazyRoute from '../components/LazyRoute'

export const Route = createFileRoute('/invitations/$token')({
  component: () => (
    <ProtectedRoute>
      <LazyRoute
        loader={() => import('@/components/invitations/AcceptInvitation')}
        fallback={<div className="p-8 text-center">Loading...</div>}
      />
    </ProtectedRoute>
  ),
})